export default {

	url(endpoint, params) {
		if(!params) {
			params = {};
		}

		Object.keys(params).forEach((key) => {
			endpoint = ("" + endpoint).replace(new RegExp('@' + key + '@', 'g'), params[key]);
		});

		return window.BASE_API_URL + endpoint;
	}

}
